import React from 'react'

const Fifty_seven = () => {
    return (
        <div className='container'>
            <h1>C Program to Find Factorial of a Number Using Recursion</h1>
            <div className='containers'>
            The factorial of a positive number n is given by: <br />
<br />
factorial of n (n!) = 1 * 2 * 3 * 4 *...  * n <br />
The factorial of a negative number doesn't exist. And the factorial of 0 is 1 <br />
            </div>
            <div className='containers'>
          <code className='library'> #include</code>  &lt;stdio.h&gt; <br/>
          <code className='keywords'>long int </code>multiplyNumbers(int n);  <br/>
          <code className='keywords'>int </code>main() &#123; <br/>
          <code className='keywords'>  int </code>n; <br/>
          <code className='library'> printf</code>("Enter a positive integer: "); <br/>
          <code className='library'>  scanf</code>("%d",&n); <br/>
          <code className='library'>printf</code>("Factorial of %d = %ld", n, multiplyNumbers(n)); <br/>
    <code className='library'>return</code> 0; <br/>
&125; <br/>

<code className='keywords'>long int</code> multiplyNumbers(int n) &#123; <br/>
<code className='keywords'>   if</code> (n&gt;=1) <br/>
<code className='library'>      return</code> n*multiplyNumbers(n-1); <br/>
<code className='keywords'>  else</code> <br/>
<code className='library'>   return</code> 1; <br/>
&125; <br/>

            </div>
        </div>
    )
}

export default Fifty_seven
